export default {
    getHeaderFieldsEprofileEletmod: state => state.headerFieldsEprofileEletmod,
    getFormActionsEprofileEletmod: state => state.formActionsEprofileEletmod,
    getActionsEprofileEletmod: state => state.actionsEprofileEletmod,
    getRowActionsEprofileEletmod: state => state.rowActionsEprofileEletmod,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileEletmod: state => state.formIsOpen,
    isGridOpenEprofileEletmod: state => state.gridIsOpen
}
